// extracted by mini-css-extract-plugin
export default {"notification-drawer":"private-page__notification-drawer"};